<script setup>
import ProForecastListPage from '@/components/ProForecastListPage.vue';

</script>

<template>
  <Suspense>
    <ProForecastListPage />
  </Suspense>
</template>
